import { Link } from "react-router-dom";

export interface Crumb {
  label: string;
  to?: string;
}

export default function Breadcrumb({ items }: { items: Crumb[] }) {
  return (
    <nav aria-label="面包屑导航" className="w-full">
      <ol className="flex flex-wrap items-center gap-x-2 gap-y-1 text-xs text-foreground-600 md:text-sm">
        <li className="flex items-center">
          <Link to="/" className="transition-colors hover:text-primary-700">
            首页
          </Link>
        </li>
        {items.map((item) => (
          <li key={item.label} className="flex items-center gap-2">
            <i className="ri-arrow-right-s-line text-foreground-400"></i>
            {item.to ? (
              <Link to={item.to} className="transition-colors hover:text-primary-700">
                {item.label}
              </Link>
            ) : (
              <span className="text-foreground-800">{item.label}</span>
            )}
          </li>
        ))}
      </ol>
    </nav>
  );
}